import "@hotwired/turbo-rails"
import { showToast } from "./lib/toast.js"
import "./library_mount.jsx"
import "./document_preview_mount.jsx"
import "./editor_mount.jsx"
import "./render_mount.jsx"
import "./documents_test_mount.jsx"
import "./tiptap_test_mount.jsx"
import "./consent.js"

window.showToast = showToast
